import './types/globals';
import SFLanguage from '@/i18n/translation.en.js';
(window as any).SFLanguage = SFLanguage;
import './editor/base/fabric-helpers';
import './editor/base/helpers';
import './editor/base/models-base';
import './editor/base/canvas-base';
import './editor/base/shapes/image-base';
import './editor/base/shapes/photo-group-base';
import './editor/base/shapes/photo-base';
import './editor/base/shapes/clipart-base';
import './editor/base/shapes/background-base';
import './editor/base/shapes/foreground-base';
import './editor/base/shapes/frame-base';
import './editor/base/shapes/group-base';
import './editor/base/shapes/text-base';
import './editor/base/shapes/filter-base';
import './editor/base/cache-base';
import './editor/base/translator';
import './editor/base/edits';
import './editor/base/renderer-base';
import './editor/shapes/image-customizer';
import './editor/shapes/text-customizer';
import './editor/models-customizer';
import './editor/canvas-customizer';
import './editor/translator-customizer';
import './editor/edits-customizer';
import './editor/base/editor.interfaces';
import './editor/base/tlf';
import './editor/container';
import './editor/editor.interface-customizer';
import './editor/errors';
import './editor/font-preloader';
import './previewer/product-preview';
